function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9102 10.8281C25.7213 13.4494 23.7768 15.4688 21.6563 15.4688C19.5357 15.4688 17.588 13.4501 17.4023 10.8281C17.209 8.10111 19.102 6.1875 21.6563 6.1875C24.2105 6.1875 26.1035 8.15074 25.9102 10.8281Z",
  stroke: "#8A8A8A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6562 19.5938C17.4558 19.5938 13.4166 21.6801 12.4046 25.7432C12.2706 26.2808 12.6077 26.8125 13.16 26.8125H30.1531C30.7055 26.8125 31.0406 26.2808 30.9085 25.7432C29.8966 21.615 25.8573 19.5938 21.6562 19.5938Z",
  stroke: "#8A8A8A",
  strokeWidth: 2,
  strokeMiterlimit: 10
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8906 11.9844C12.7398 14.0779 11.1684 15.7266 9.47461 15.7266C7.78079 15.7266 6.20684 14.0785 6.0586 11.9844C5.90456 9.80654 7.43403 8.25 9.47461 8.25C11.5152 8.25 13.0447 9.8465 12.8906 11.9844Z",
  stroke: "#8A8A8A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2773 19.7224C12.114 19.1893 10.8326 18.9844 9.4746 18.9844C6.12304 18.9844 2.89393 20.6505 2.08505 23.8957C1.9787 24.325 2.24811 24.7497 2.68897 24.7497H9.92577",
  stroke: "#8A8A8A",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
function SvgIonPeopleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonPeopleOutline);
export default __webpack_public_path__ + "static/media/ion_people-outline.eed32ddce1701abb71406b295dcec5df.svg";
export { ForwardRef as ReactComponent };